import { ReactNode } from "react";
import styled, { css } from "styled-components";

type InlineButtonProps = {
    variant?: "primary" | "default" | "secondary";
    underline?: boolean;
    children?: ReactNode;
    onClick?: () => void | Promise<void>;
    size?: "mini" | "default";
};

export const ResetButtonStyles = css`
    background: none;
    -webkit-appearance: none;
    -webkit-font-smoothing: inherit;
    -moz-osx-font-smoothing: inherit;
    border: none;
    margin: 0;
    padding: 0;
`;

const Text = styled.button<InlineButtonProps>`
    ${ResetButtonStyles};
    cursor: pointer;

    ${(props) => {
        switch (props.variant) {
            case "primary":
                return css`
                    color: var(--accent);
                `;
            case "default":
                return css`
                    color: var(--text);
                `;
            case "secondary":
                return css`
                    color: var(--disabled-text);
                `;
        }
    }}
    &:hover {
        color: var(--accent-shadow);
    }

    ${(props) =>
        props.size === "mini" &&
        css`
            font-size: 0.85rem;
        `}

    ${(props) =>
        props.underline &&
        css`
            text-decoration: underline;
            text-decoration-thickness: 2px;
            text-underline-offset: 1px;
        `}
`;

function InlineButton({ underline, children, onClick, size = "default", variant = "secondary" }: InlineButtonProps) {
    return (
        <>
            <Text underline={underline} onClick={onClick} size={size} variant={variant}>
                {children}
            </Text>
        </>
    );
}

export default InlineButton;
